<template>
    <!-- designs -->
    <template v-if="solutions">
        <div class="flex items-center justify-between mt-8">
            <p class="uppercase font-semibold text-gray-700"> PROPOSED SOLUTIONS
                <span class="text-sm normal-case font-normal">(Possible solutions based on the filtered materials and performance)</span>
            </p>
            <a href="https://lookerstudio.google.com/u/0/reporting/f774df22-377b-44b8-b2ca-94113ba69ca0/page/p_f0lzfkoydd" target="_blank">
                <div class="flex items-center rounded-full px-4 py-2 bg-moss shadow-md cursor-pointer">
                    <CircleStackIcon class="icon icon-small thick white mr-2" />
                    <p class="text-white text-xs uppercase">Explore Material Data</p>
                </div>
            </a>
        </div>
        <div class="flex items-start mt-3">
            <div v-if="solutions" class="grid grid-cols-3 gap-x-4 gap-y-8 mt-5">
                <template v-for="solution in solutions" :key="solution.text">
                    <div class="flex flex-col border bg-white rounded-md shadow-sm">
                        <img :src="require(`@/assets/images/${solution.img}`)" class="blur p-8">
                        <div class="border-t px-4 py-3 flex justify-between items-center">
                            <div>
                                <p class="uppercase font-semibold nude">{{ solution.text }}</p>
                                <p class="text-xs normal-case font-normal text-gray-400">Click the icon to save this solution</p>
                            </div>
                            <StarIcon class="top-2 right-2 icon icon-small thick star mr-2" />
                        </div>
                    </div>
                    <!-- <div class="bg-white shadow-md border p-8 rounded-lg cursor-pointer relative flex flex-col">
                        <p class="combo-label bg-nude">{{ solution.text }}</p>
                        
                        <div>
                            
                        </div>
                        
                    </div> -->
                </template>
            </div>
        </div>
    </template>
</template>
<script setup lang="ts">
import { CircleStackIcon, StarIcon } from '@heroicons/vue/24/outline';
import { defineProps } from 'vue';

defineProps(['solutions'])
</script>
<style lang="scss" scoped>
.combo-label {
    position: absolute;
    top: -10px;
    left: 27px;
    // transform: translate(-50%, -50%); 
    padding: 0.3rem 1rem;
    font-size: 0.85rem;
    color: white;
    text-transform: uppercase;
    border-radius: 6px;
    font-weight: 400;
}
.star {
    stroke: $peach;
}
.nude {
    color: $peach;
}
</style>